import useFetch from '@/composables/useFetch';
import { PaginationResponse } from '@/model/api';
import { Hitomi, HitomiOption, HitomiPaginationRequest } from '@/model/hitomi';
import { HttpStatusCode } from 'axios';

export async function getHitomiPagination(query: HitomiPaginationRequest) {
	const res = await useFetch<PaginationResponse<Hitomi>>({
		method: 'GET',
		url: '/hitomi',
		params: query,
		signalUUID: `GET_HITOMI_PAGINATION`
	});
	return res.data;
}

export async function getHitomiDetail(hitomiUUID: string) {
	const res = await useFetch<Hitomi>({
		method: 'GET',
		url: '/hitomi/' + hitomiUUID
	});
	return res.data;
}

export async function createHitomi(data: Hitomi, file?: File) {
	const formData = new FormData();
	formData.append('data', JSON.stringify(data));
	if (file) {
		formData.append('file', file);
	}
	return await useFetch({
		method: 'POST',
		url: '/hitomi',
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
}

export async function updateHitomi(data: Hitomi, file?: File) {
	const formData = new FormData();
	if (data) {
		formData.append('data', JSON.stringify(data));
	}
	if (file) {
		formData.append('file', file);
	}
	return await useFetch({
		method: 'PATCH',
		url: '/hitomi/' + data.hitomiUUID,
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
}

export async function favoriteHitomi(hitomiUUID: string, isFavorite: boolean) {
	return await useFetch({
		method: 'PATCH',
		url: `/hitomi/${hitomiUUID}/favorite`,
		data: { isFavorite }
	});
}

export async function deleteHitomi(hitomiUUID: string) {
	return await useFetch({
		method: 'DELETE',
		url: '/hitomi/' + hitomiUUID
	});
}

export async function getHitomiImage(imageURL: string) {
	const res = await useFetch<Blob>({
		method: 'POST',
		url: '/hitomi/image',
		data: { imageURL },
		responseType: 'blob'
	});
	if (res.status === HttpStatusCode.Ok) {
		return res.data;
	}
}

export async function getHitomiOptions() {
	const res = await useFetch<HitomiOption>({
		method: 'GET',
		url: '/hitomi/option'
	});
	if (res.status === HttpStatusCode.Ok) {
		return res.data;
	}
}
